import { AxiosPromise } from 'axios';

import {
  ILiveAsset,
  IThumbnailParams,
  IAssetCreate,
  IAssetUpdate,
  IDeleteParams,
} from './interfaces';
import { vaultApi } from '../api';

const basePath = '/assets';

export const getAsset = <T>(id: string): AxiosPromise<any> => vaultApi.getInstance().get(`${basePath}/${id}`);

export const saveLiveAsset = <T>(params: ILiveAsset): AxiosPromise<any> => vaultApi.getInstance().post(`${basePath}/live`, params);

export const saveAsset = <T>(params: IAssetCreate): AxiosPromise<any> => vaultApi.getInstance().post(`${basePath}`, params);

export const updateAsset = <T>(id: string, updates: any): AxiosPromise<any> => vaultApi.getInstance().put(`${basePath}/${id}`, updates);

export const bulkUpdateAsset = <T>(updates: any[]): AxiosPromise<any> => vaultApi.getInstance().post(`${basePath}/bulkupdate`, updates);

export const updateAssetByExchangeScheduleId = <T>(id: string, exchangeScheduleId: string): AxiosPromise<any> => vaultApi.getInstance().put(`${basePath}/${id}/exchangeScheduleId/${exchangeScheduleId}`);

export const getThumbnailByVideoId = <T>(id: string, params: IThumbnailParams): AxiosPromise<any> => vaultApi.getInstance().get(`${basePath}/${id}/thumbnail`, { params });

export const terminateLiveStream = <T>(id: string): AxiosPromise<any> => vaultApi.getInstance().post(`${basePath}/terminateLive/${id}`);

export const restartLiveStream = <T>(id: string): AxiosPromise<any> => vaultApi.getInstance().post(`${basePath}/restartLive/${id}`);

// Rebuilds the MP4 for a live event whose footage was recorded but never
// processed. Only valid for streams stuck in Error, Restarting or AwaitingSource.
export const recoverLiveStream = <T>(id: string): AxiosPromise<any> => vaultApi.getInstance().post(`${basePath}/recoverLive/${id}`);

// Whether this event has footage that could actually be rebuilt. A recoverable
// status is not enough on its own - an event whose feed never published has
// nothing behind it, and published segments are cleaned up two days after the
// event - so this is a live check rather than a field on the asset.
export const recoverLiveStreamAvailable = <T>(id: string): AxiosPromise<{ data: { recoverable: boolean } }> => vaultApi.getInstance().get(`${basePath}/recoverLive/${id}/available`);

export const getExchangeInfoFiles = <T>(): AxiosPromise<any> => vaultApi.getInstance().get(`${basePath}/exchangeInfo/files`);

export const deleteAssets = <T>(params: IDeleteParams): AxiosPromise<any> => vaultApi.getInstance().post(`${basePath}/delete`, params);

export const refreshAssets = <T>(ids: string[]): AxiosPromise<any> => vaultApi.getInstance().put(`${basePath}/refresh/refresh`, { ids });
